import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { Facebook, Linkedin, Twitter, Instagram, MapPin, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0A0A0A] border-t border-white/10 pt-16 pb-8" data-id="element-72" data-mp="32ovukn0cqfgg">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-73" data-mp="36oxzr65apr0h">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-74" data-mp="36ppjnjpj60ax">
          {/* Brand Column */}
          <div className="space-y-6" data-id="element-75" data-mp="3ud7iu0b4k0nx">
            <span className="inline-flex p-2 bg-black border border-white/80 rounded-sm" data-id="element-76" data-mp="38zaivynj750">
              <Logo className="h-24" data-id="element-77" data-mp="3levk1b03twke" />
            </span>
            <p className="text-white font-serif text-xl" data-id="element-78" data-mp="3lggb2qn7mxdi">Sinclair Develops.</p>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-79" data-mp="3qbvo5gde8p8v">
              We identify opportunities and bring together the planning, design,
              construction and management necessary to turn them into successful
              properties throughout Southwest Florida.
            </p>
            <a href="https://sinclairdevelops.com" className="inline-block text-[#C5A55A] text-sm tracking-[0.15em] uppercase hover:text-[#D4AF37] transition-colors" data-id="element-80" data-mp="3la288r748xtn">
              SinclairDevelops.com
            </a>
          </div>

          {/* Quick Links */}
          <div data-id="element-81" data-mp="3q7bvc0718xeb">
            <h3 className="text-[#C5A55A] font-serif text-lg mb-6" data-id="element-82" data-mp="3qazr75zy9vw7">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-83" data-mp="33xe1y3atysi">
              {['Home', 'About', 'Projects', 'Services', 'Contact'].map(item => <li key={item} data-id="element-84" data-mp="htd4fcyx427o">
                  <Link to={item === 'Home' ? '/' : `/${item.toLowerCase()}`} className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-85" data-mp="hsacd1puztq6">
                    {item}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-86" data-mp="tvcwfj28tpax">
            <h3 className="text-[#C5A55A] font-serif text-lg mb-6" data-id="element-87" data-mp="tvw8ij57pjh1">
              What We Develop
            </h3>
            <ul className="space-y-3" data-id="element-88" data-mp="yuzbzz5jnhmw">
              <li className="text-gray-400 text-sm" data-id="element-89" data-mp="yrv0egpr1jm7">Site Development</li>
              <li className="text-gray-400 text-sm" data-id="element-90" data-mp="13rpuet4tmpbh">Commercial Development</li>
              <li className="text-gray-400 text-sm" data-id="element-91" data-mp="18l2csliwpzvs">Residential Development</li>
              <li className="text-gray-400 text-sm" data-id="element-92" data-mp="1cm47qq5sjpry">Redevelopment</li>
              <li className="text-gray-400 text-sm" data-id="element-93" data-mp="1cnytu7sstnxm">Tenant Improvements</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-94" data-mp="1mjihk6x7lgba">
            <h3 className="text-[#C5A55A] font-serif text-lg mb-6" data-id="element-95" data-mp="1ml3eu4awrdcu">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-96" data-mp="1rid4nl27lr17">
              <li className="flex items-start gap-3 text-gray-400 text-sm" data-id="element-97" data-mp="3ob57041gd35n">
                <MapPin className="w-5 h-5 text-[#C5A55A] shrink-0" data-id="element-98" data-mp="3od86deohw8n1" />
                <a href="https://www.google.com/maps/search/?api=1&query=329+NE+3rd+Ave+Cape+Coral+FL+33909" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-99" data-mp="3tb1be4e2awlq">
                  329 NE 3rd Ave
                  <br data-id="element-100" data-mp="21kpe9pubhx1k" />
                  Cape Coral, FL 33909
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm" data-id="element-101" data-mp="1wlm8u4afdot2">
                <Phone className="w-5 h-5 text-[#C5A55A] shrink-0" data-id="element-102" data-mp="2tdg1jau0wbeo" />
                <a href="tel:239-810-9482" className="hover:text-white transition-colors" data-id="element-103" data-mp="2pc4kvut4n0im">
                  239-810-9482
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm" data-id="element-104" data-mp="2fd5bub4g92v3">
                <Mail className="w-5 h-5 text-[#C5A55A] shrink-0" data-id="element-105" data-mp="18ynw9hpff10f" />
                <a href="mailto:info@sinclairdevelops.com" className="hover:text-white transition-colors" data-id="element-106" data-mp="18vrxjr5r88ax">
                  info@sinclairdevelops.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-107" data-mp="2iv1ccdhur22o">
          <p className="text-gray-500 text-xs text-center md:text-left" data-id="element-108" data-mp="2ntmh8q81u9xg">
            © {new Date().getFullYear()} Sinclair Development. All rights
            reserved.
            <span className="mx-2 text-white/20" data-id="element-109" data-mp="3bhvuh3r75pcz">|</span>
            <span className="text-[#C5A55A] tracking-wider" data-id="element-110" data-mp="3fk0r8bcxz23u">
              FL License #CGC1541661
            </span>
          </p>
          <div className="flex items-center gap-4" data-id="element-111" data-mp="31nn6mtd42kl5">
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-112" data-mp="36jknd0sadsyg">
              <Facebook className="w-4 h-4" data-id="element-113" data-mp="1q52mwgzqx2xh" />
            </a>
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-114" data-mp="1v5qkjlihci0o">
              <Twitter className="w-4 h-4" data-id="element-115" data-mp="1nkefosq1xxzi" />
            </a>
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-116" data-mp="1inny20ylmubz">
              <Linkedin className="w-4 h-4" data-id="element-117" data-mp="1wm43zpon0gt2" />
            </a>
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-118" data-mp="1rn1bf4pug31z">
              <Instagram className="w-4 h-4" data-id="element-119" data-mp="13yrpm2smrfau" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}